/**
 * Design tokens lifted verbatim from the Claude Design prototype.
 *
 * Everything is oklch (Chrome 111+ / Safari 15.4+ — fine on any panel you'd
 * actually mount, but it rules out ancient Android WebViews).
 */
export const t = {
  bg: 'oklch(0.155 0.012 60)',
  bgGradient:
    'radial-gradient(130% 85% at 10% -10%, oklch(0.255 0.035 150) 0%, oklch(0.155 0.012 60) 58%)',
  surface: 'oklch(0.225 0.012 60)',
  surfaceRaised: 'oklch(0.235 0.012 60)',
  surfaceSunken: 'oklch(0.205 0.012 60)',
  control: 'oklch(0.28 0.012 60)',
  controlHi: 'oklch(0.31 0.012 60)',
  ink: 'oklch(0.97 0.008 80)',
  inkMuted: 'oklch(0.7 0.015 70)',
  inkFaint: 'oklch(0.62 0.015 70)',
  accent: 'oklch(0.82 0.16 130)',
  accentInk: 'oklch(0.2 0.05 130)',
  danger: 'oklch(0.72 0.17 25)',
  hairline: '1px solid oklch(1 0 0 / 0.07)',
  hairlineStrong: '1px solid oklch(1 0 0 / 0.14)',
  mono: "'IBM Plex Mono', ui-monospace, monospace",
  sans: "'Space Grotesk Variable', 'Space Grotesk', system-ui, sans-serif",
} as const;

/** The kicker style repeated above every screen title. */
export const kicker: React.CSSProperties = {
  fontFamily: t.mono,
  fontSize: 13,
  letterSpacing: '0.16em',
  color: t.inkFaint,
};

export const screenTitle: React.CSSProperties = {
  fontSize: 46,
  fontWeight: 500,
  letterSpacing: '-0.045em',
  marginTop: 6,
};

export function memberColor(hue: number): string {
  return `oklch(0.78 0.14 ${hue})`;
}
